import Repository from '../../../../../foundation/repository/Repository';
import ApiData from '../../../../../foundation/repository/ApiData';
import Course from '../aggregates/course/Course';
import User from '../../../users/domain/aggregates/user/User';
import CourseVisibility from '../aggregates/course/CourseVisibility';

export default class CourseRepository extends Repository<Course> {

	public getAll () {
		return super.getAll();
	}

	public mapObject (data: ApiData) {
		return new Course(
			data.id<Course>('id'),
			data.id<User>('userId'),
			data.string('name'),
			new CourseVisibility(data.string('visibility'))
		);
	}
}


// WEBPACK FOOTER //
// ./code/project/modules/lessons/domain/repositories/CourseRepository.ts